import {FormikProps} from 'formik';

import {Autocomplete, Grid, TextField, Typography, Theme} from '@mui/material';

import {BatchInvitationsFormValues, Option} from './BatchInvitationsModal.types';
import {orangeColors} from '../../../../layouts/theme/designSystem';
import {getFieldStyle} from '../../../../layouts/theme/FieldStyles';

interface Props {
  formik: FormikProps<BatchInvitationsFormValues>;
  theme: Theme;
  departmentOptions: Option[];
  jobPostingOptions: string[];
  locationOptions: string[];
  departmentLabel: string;
  departmentPlaceholder: string;
  jobPostingLabel: string;
  jobPostingPlaceholder: string;
  locationLabel: string;
  locationPlaceholder: string;
  onDepartmentChange: (value: Option | null) => void;
  onJobPostingChange: (value: string) => void;
  onLocationChange: (value: string) => void;
}

const fieldInputPropsStyle = {
  borderColor: orangeColors[5],
  backgroundColor: orangeColors[7],
};

export const BatchInvitationsFormFields = ({
  formik,
  theme,
  departmentOptions,
  jobPostingOptions,
  locationOptions,
  departmentLabel,
  departmentPlaceholder,
  jobPostingLabel,
  jobPostingPlaceholder,
  locationLabel,
  locationPlaceholder,
  onDepartmentChange,
  onJobPostingChange,
  onLocationChange,
}: Props) => {
  const selectedDepartment =
    departmentOptions.find((department) => department.value === formik.values.departmentId) || null;

  return (
    <>
      <Grid item xs={12}>
        <Typography variant='h4' marginBottom='4px' marginTop='8px'>
          {departmentLabel}
        </Typography>
        <Autocomplete
          size='small'
          value={selectedDepartment}
          onChange={(_, value) => onDepartmentChange(value)}
          options={departmentOptions}
          getOptionLabel={(option) => option.label}
          disableClearable={false}
          forcePopupIcon={departmentOptions.length > 0}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              sx={getFieldStyle(theme)}
              placeholder={departmentPlaceholder}
              InputProps={{
                ...params.InputProps,
                sx: fieldInputPropsStyle,
              }}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='h4' marginBottom='4px' marginTop='8px'>
          {jobPostingLabel}
        </Typography>
        <Autocomplete
          freeSolo
          size='small'
          value={formik.values.jobPosting}
          onInputChange={(_, value) => onJobPostingChange(value)}
          options={jobPostingOptions}
          forcePopupIcon={jobPostingOptions.length > 0}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              sx={getFieldStyle(theme)}
              placeholder={jobPostingPlaceholder}
              error={!!(formik.touched.jobPosting && formik.errors.jobPosting)}
              helperText={formik.touched.jobPosting ? formik.errors.jobPosting : ''}
              InputProps={{
                ...params.InputProps,
                sx: fieldInputPropsStyle,
              }}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='h4' marginBottom='4px' marginTop='8px'>
          {locationLabel}
        </Typography>
        <Autocomplete
          freeSolo
          size='small'
          value={formik.values.location}
          onInputChange={(_, value) => onLocationChange(value)}
          options={locationOptions}
          forcePopupIcon={locationOptions.length > 0}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              sx={getFieldStyle(theme)}
              placeholder={locationPlaceholder}
              error={!!(formik.touched.location && formik.errors.location)}
              helperText={formik.touched.location ? formik.errors.location : ''}
              InputProps={{
                ...params.InputProps,
                sx: fieldInputPropsStyle,
              }}
            />
          )}
        />
      </Grid>
    </>
  );
};
